import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ComboPackageManagment } from '../_services/combo_package';
import { AlertService } from '../_helpers/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RoutingService } from '../_services/routing.service';
import { ExcelService } from '../_services/excel.service';
import { Title } from '@angular/platform-browser';
import { CommonService } from '../_services/common.service';

@Component({
  selector: 'app-vendors-revenue',
  templateUrl: './vendors-revenue.component.html',
  styleUrls: ['./vendors-revenue.component.scss']
})
export class VendorsRevenueComponent implements OnInit {
  showLoader: boolean = false;
  pageTitle: string = 'Vendors Revenue';
  @ViewChild('statusOrderBy', { static: false }) statusOrderBy!: ElementRef;
  statusOrderByinfo: string = "pastWeek";
  tabsArray: any[] = [];
  isBackPressed: boolean = false;
  allData: any;
  avtar: string = this._commonService.avtar;

  constructor(
    private comboPackageManagment: ComboPackageManagment,
    public routing: RoutingService,
    private _commonService: CommonService,
    private title: Title
  ) { }

  async ngOnInit() {
    this.title.setTitle(this.pageTitle);
    await this.getComboPackage();
  }

  backTabs() {
    this.tabsArray.pop();
    let info: any = this.tabsArray.length - 1;
    let elem = document.getElementById(`${this.tabsArray[info]}-tab`)
    if (elem) {
      this.isBackPressed = true;
      elem.click();
    }
  }

  getComboPackage() {
    this.statusOrderByinfo = this.statusOrderBy?.nativeElement?.value ? this.statusOrderBy?.nativeElement?.value : this.statusOrderByinfo;
    this.allData = [];
    this.showLoader = true;
    this.comboPackageManagment.getAllVendorsRevenue(this.statusOrderByinfo).subscribe({
      next: (response: any) => {
        if (response && response.isSuccess) {
          this.showLoader = false;
          this.allData = response.data;
        } else {
          this.showLoader = false;
        }
      },
      error: (errorResponse: any) => {
        this.showLoader = false;
      },
    });
  }

}

